<script>
    import {fade, scale} from 'svelte/transition';

    export let isOpen = false;

</script>

<div class="icon">
    {#if isOpen}
        <svg height="32" width="32" version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
        <style type="text/css">
            .st0 {
                fill: #1D1D1B;
            }
        </style>
            <g>
            <rect x="22.7" y="4.8" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -4.4644 21.3033)" class="st0"
                  width="1.5"
                  height="22.6"/>
                <rect x="-2.8" y="15.2" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -8.7936 10.689)" class="st0"
                      width="22.6" height="1.5"/>
        </g>
    </svg>
    {:else}
        <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" height="32" width="32"
             viewBox="0 0 32 32">
            <defs>
                <style>.cls-1 {
                    fill: #1d1d1b;
                }
                </style>
            </defs>
            <title>arrow-down</title>
            <rect class="cls-1" x="7.75" y="4.68" width="1.52" height="22.56"
                  transform="translate(-8.79 10.69) rotate(-45)"/>
            <rect class="cls-1" x="12.2" y="15.28" width="22.56" height="1.52"
                  transform="translate(-4.46 21.3) rotate(-45)"/>
        </svg>
    {/if}
</div>
